import { CardBase } from './card-base.class';

export const classes = [CardBase];

export * from './card-base.class';
